import amioWebappHttpClient from '@/services/amio-api/http/amio-webapp.http-client'

class MessageService {
  constructor() {
    this.path = '/messages'
  }

  sendMessage(message) {
    return amioWebappHttpClient
      .post(this.path, message)
      .then(response => response.data)
  }
}

export default new MessageService()
